import { createPortal } from "react-dom";
import { PropertyPalLayout } from "./pp-layout";

export const PropertyPalContainer = () => {
  return createPortal(<PropertyPalLayout />, document.body);
};
